import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import React from "react";
import MyErrorBoundary from "../../components/Errors/ErrorBoundary";
import {StylesProvider, createGenerateClassName} from "@material-ui/core/styles";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {message} from "para-ui";
import {persistor, store} from "../../store";
import ForgetPassword from "../../views/forgetPassword";
import * as serviceWorker from "../../serviceWorker";
import {dependencies, version, name} from "../../../package.json";
import {whiteTheme} from "../../theme";
import "para-ui/dist/para-ui.esm.css";
import {Context, Debugger} from "para-lib";
import {IntlProvider} from "react-intl";
import SKHelp from "../../views/SKHelp"; // 国际化

const generateClassName = createGenerateClassName({
    seed: "selfcare-portal"
});
message.config({
    duration: 3,
    maxCount: 1,
});

window.ParaWeb = {
    name,
    version,
    env: "dev",
    buildTime: "7/17/2020, 9:23:50 AM",
    ParaUI: dependencies["para-ui"],
    ParaLib: dependencies["para-lib"]
};
const Lang = {
    zh: {
        passwordBack: "密码找回",
        username: "用户名",
        enterUsername: "请输入手机号",
        usernameNotEmpty: "用户名不能为空",
        wayBack: "找回方式",
        selectRetrievalMethod: "请选择找回方式",
        retrievalMethodNotEmpty: "找回方式不能为空",
        contactAdministrator: "请输入手机号获取找回方式，如果无法获取，请拨打4009201717",
        verificationCode: "验证码",
        enterVerificationCode: "请输入验证码",
        verificationCodeNotEmpty: "验证码不能为空",
        newPassword: "新密码",
        enterNewPassword: "请输入新密码",
        newPasswordNotEmpty: "新密码不能为空",
        confirmNewPassword: "确认新密码",
        pleaseConfirmNewPassword: "请确认新密码",
        confirmNewPasswordNotEmpty: "确认新密码不能为空",
        complete: "完成",
        getVCode: "获取验证码",
        secondsLater: "秒后重发",
        checkTwoPasswords: "两次密码输入不一致，请检查"
    },
    en: {
        passwordBack: "Password back",
        username: "User name",
        enterUsername: "Please enter a user name",
        usernameNotEmpty: "User name cannot be null",
        wayBack: "Way back",
        selectRetrievalMethod: "Please select the retrieval method",
        retrievalMethodNotEmpty: "retrieval method cannot be null",
        contactAdministrator: "The retrieval method is not set, please contact the administrator!",
        verificationCode: "Verification code",
        enterVerificationCode: "Please enter the verification code",
        verificationCodeNotEmpty: "Verification code cannot be null",
        newPassword: "New password",
        enterNewPassword: "Please enter a new password",
        newPasswordNotEmpty: "New password cannot be null",
        confirmNewPassword: "Confirm newPassword",
        pleaseConfirmNewPassword: "Please confirm the new password",
        confirmNewPasswordNotEmpty: "Confirm newPassword cannot be null",
        complete: "Complete",
        getVCode: "Get vCode",
        secondsLater: "Seconds later",
        checkTwoPasswords: "The two passwords are not consistent, please check"
    }
};

const getLang = () => {
    let jsSrc = navigator.language.toLowerCase();
    if (jsSrc.indexOf("zh") >= 0) {
        // 假如浏览器语言是中文
        return "zh";
    } else if (jsSrc.indexOf("en") >= 0) {
        // 假如浏览器语言是英文
        return "en";
    } else {
        // 假如浏览器语言是其它语言
        return jsSrc;
    }
};

const getLange = () => {
    let lang = getLang();
    const setting = JSON.parse(localStorage.getItem("ParaView") || "{}")?.setting || "{}";
    const storageLang = JSON.parse(setting)?.language;
    if (storageLang && (storageLang === "zh-CN" || storageLang === "zh")) {
        lang = "zh";
    }
    if (storageLang && (storageLang === "en")) {
        lang = "en";
    }
    return lang;
};

const init = async (debug: Array<string> = []) => {
    if (process.env.NODE_ENV === "development") {
        await Debugger.init(debug);
    } else {
        await Context.load();
    }

    const getLocalMessage = () => {
        let msg: object;
        const language = getLange();
        if (language === "zh-CN" || language === "zh") {
            msg = Lang.zh;
        } else {
            msg = Lang.en;
        }
        return {...msg};
    };

    ReactDOM.render(
        <Provider store={store}>
            <PersistGate persistor={persistor} loading={null}>
                <MyErrorBoundary>
                    <IntlProvider key="intl" locale={getLange()} messages={getLocalMessage()}>
                        <StylesProvider generateClassName={generateClassName}>
                            <MuiThemeProvider theme={whiteTheme}>
                                <SKHelp/>
                            </MuiThemeProvider>
                        </StylesProvider>
                    </IntlProvider>
                </MyErrorBoundary>

            </PersistGate>
        </Provider>,

        document.getElementById("SKHelp")
    );
    serviceWorker.unregister();
};

init(["http://192.168.7.27:9098", "http://192.168.2.37:10000"]);

serviceWorker.unregister();
